/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   style.ts
 */

import { Theme } from '@chakra-ui/react'
import { css } from '@emotion/react'

import {
  CAROUSEL_ARROW_CLASS,
  CAROUSEL_CONTAINER_CLASS,
  CAROUSEL_ITEM_CLASS,
  CAROUSEL_SLIDER_CLASS,
} from './constants'
import { CarouselWrapperStyleType, EmotionType } from './types'

const handleCss = (cssObj: EmotionType, theme: Theme) =>
  cssObj instanceof Function ? cssObj(theme) : cssObj ?? ''

// See readme.md for details
export const carouselWrapperStyle =
  ({ wrapperCss, itemCss, containerCss, sliderCss }: CarouselWrapperStyleType) =>
  (theme: Theme) =>
    css`
      ${handleCss(wrapperCss, theme)}
      .${CAROUSEL_ITEM_CLASS} {
        ${handleCss(itemCss, theme)}
      }
      .${CAROUSEL_CONTAINER_CLASS} {
        ${handleCss(containerCss, theme)}
      }
      .${CAROUSEL_SLIDER_CLASS} {
        ${handleCss(sliderCss, theme)}
      }
      label: carouselRoot;
    `

// Used as default prop
export const carouselWrapper = css`
  height: 100%;
  &:hover,
  &:focus,
  &:focus-within {
    .${CAROUSEL_ARROW_CLASS} {
      opacity: 1;
    }
  }
`
// Used as default prop
export const carouselItem = css`
  width: fit-content;
`
// Used as default prop
export const carouselContainer = css`
  height: 100%;
`

// Used as default prop
export const carouselSlider = css`
  padding: 0px;
  margin: 0px;
  height: 100%;
`
